<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 3"
      show-footer
      :footer-method="amount"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'D' || row.orderStatus === 'T'
              ? 'danger'
              : row.orderStatus === 'R'
              ? 'warning'
              : row.orderStatus === 'Y' ||
                row.orderStatus === 'P' ||
                row.orderStatus === 'C'
              ? 'success'
              : 'light'
          "
        >
          {{ row.v_orderStatus }}
        </el-tag>
      </template>
      <template v-slot:showTeamName="{ row }">
        {{ row.depName }}-{{ row.teamName }}
      </template>
      <template v-slot:hasShipping="{ row }">
        <el-tag
          size="mini"
          :type="row.hasShipping === 'Y' ? 'success' : 'light'"
        >
          {{ row.v_hasShipping }}
        </el-tag>
      </template>
      <template v-slot:v_qty="{ row }">
        {{ row.v_qty }}
      </template>
      <template v-slot:showSales="{ row }">
        {{ row.v_salePriceAmount }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import Math from '@/libs/util.math.js'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      const {
        goodsQty = 0,
        priceAmount = 0,
        salePriceAmount = 0,
        netSalePriceAmount = 0,
        usdPriceAmount = 0,
        usdSalePriceAmount = 0,
        usdNetSalePriceAmount = 0,
        usdOrderProfit = 0,
      } = this.tableData[0]?.sumData || {}
      return [
        [
          '',
          this.$l('INDEX.total') || '合计',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          this.format(goodsQty),
          this.format(priceAmount),
          '',
          this.format(salePriceAmount),
          this.format(netSalePriceAmount),
          '',
          '',
          this.format(usdPriceAmount),
          this.format(usdSalePriceAmount),
          this.format(usdNetSalePriceAmount),
          this.format(usdOrderProfit),
        ],
      ]
    },
  },
  methods: {
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'order-dashboard-detail',
        params: { ...params, pageType },
      })
    },
    add(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
    },
    amount() {
      return this.footerData
    },
  },
}
</script>
